// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lGFr","col":"styles_col__39dLY"};